import { APIResponse } from "../APITypes";
import { csrfHeaders } from '../csrf';

export default class MailEndpoint {
    static async SendByOptedIn(email: {subject: string, html: string, attachments?: any}): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/mail/opted-in',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(email)
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Error occurred while sending emails.");
        }
        return await response.json();
    }

    static async SendByRecipientList(email: {to: string[], subject: string, html: string, attachments?: any}): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/mail/send-to-recipients',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(email)
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Error occurred while sending emails.");
        }
        return await response.json();
    }

    static async SendReminder(course_event_id: number): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/mail/send-reminder',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({course_event_id: course_event_id})
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Error occurred while sending emails.");
        }
        return await response.json();
    }

    static async SendLink(course_event_id: number, link: string): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/mail/send-link',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({course_event_id: course_event_id, link: link})
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Error occurred while sending emails.");
        }
        return await response.json();
    }

    static async SendSurvey(course_event_id: number): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/mail/send-survey',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({course_event_id: course_event_id})
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Error occurred while sending surveys.");
        }
        return await response.json();
    }

    static async SendCertificates(course_event_id: number): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/mail/send-certificates',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({course_event_id: course_event_id})
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Error occurred while sending certificates.");
        }
        return await response.json();
    }
}